import React from 'react';

import IMG_READER from 'assets/images/pos/reader-successful.png';
import { useTranslation } from 'providers/GILT.provider';

import CN from './MessageOffline.module.scss';

const MessageSuccess = () => {
  const { t } = useTranslation();
  return (
    <div data-bem="MessageSuccess">
      <div>
        <img src={IMG_READER} alt="POS reader with a card over it" className={CN.image} />
      </div>
      <div className={CN.title}>
        {t('composite.posMessages.successPart1')}
        <br />
        {t('composite.posMessages.successPart2')}
      </div>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default MessageSuccess;
